import { Link } from "react-router-dom";
import { Waves } from "lucide-react";
import PageMeta from "./PageMeta";

export default function JustTidesPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Just Tides — Cornwall Tide Times | Redruth Sea Angling Association"
        description="Free tide times and tide charts for Cornwall sea anglers — plan your next fishing trip with Just Tides from Redruth Sea Angling Association."
        keywords="Cornwall tide times, tide charts Cornwall, sea fishing tides Cornwall, just tides"
        url="https://www.redruthseaanglingassociation.co.uk/just-tides"
      />
      <div className="mx-auto max-w-3xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8 flex items-start gap-4">
          <div className="shrink-0 rounded-xl border border-cyan-400/20 bg-cyan-500/10 p-3">
            <Waves className="h-6 w-6 text-cyan-400" />
          </div>
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-cyan-400">Angler's Tools</p>
            <h1 className="heading-glow mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">Just Tides</h1>
            <p className="mt-4 text-base leading-7 text-slate-400">
              Just Tides is your go-to app for accurate and up-to-date tide times for all major coastal
              locations in the United Kingdom &amp; Ireland. Get detailed tide charts along with sunrise,
              sunset, and moon phase times to plan your coastal activities with confidence.
            </p>
          </div>
        </div>

        <div className="mt-12 space-y-8">

          <div className="rounded-2xl border border-cyan-400/20 bg-cyan-500/5 p-6 sm:p-8 panel-lift">
            <h2 className="text-lg font-bold text-white mb-3">What Just Tides gives you</h2>
            <ul className="space-y-3">
              {[
                "Accurate, up-to-date tide times for all major UK & Ireland coastal locations",
                "Detailed tide charts so you can visualise the full tidal cycle at a glance",
                "Sunrise and sunset times to help you plan your sessions around the light",
                "Moon phase information — invaluable for fishing around spring and neap tides",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-cyan-400" />
                  <p className="text-sm leading-7 text-slate-300">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-6 sm:p-8 panel-lift">
            <p className="text-base font-semibold text-white mb-1">Just Tides on the App Store</p>
            <p className="text-sm text-slate-400 mb-5">Free to download for iPhone and Android.</p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="https://apps.apple.com/gb/app/just-tides-tide-times/id6621217811"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border border-cyan-400/30 bg-cyan-500/10 px-5 py-3 text-sm font-semibold text-cyan-300 transition hover:bg-cyan-500/20"
              >
                <Waves className="h-4 w-4 shrink-0" />
                Download on the App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.justtides.app"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border border-emerald-400/30 bg-emerald-500/10 px-5 py-3 text-sm font-semibold text-emerald-300 transition hover:bg-emerald-500/20"
              >
                <Waves className="h-4 w-4 shrink-0" />
                Get it on Google Play
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
